(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new Map();
  function init(scope = document) {
    scope.querySelectorAll('.ib-story').forEach(root => {
      if (instances.has(root)) return;
      const controller = new AbortController();
      const opts = { signal: controller.signal };
      const tabs = [...root.querySelectorAll('[data-story-tab]')];
      const panels = [...root.querySelectorAll('[data-story-panel]')];
      function activate(index, focus = false) {
        tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', String(on));
          tab.tabIndex = on ? 0 : -1;
          if (on && focus) tab.focus({ preventScroll: true });
        });
        panels.forEach((panel, i) => {
          panel.hidden = i !== index;
          panel.classList.toggle('ib-story-is-entering', i === index && !reduced.matches);
        });
      }
      if (tabs.length && panels.length) {
        root.classList.add('ib-story-enhanced');
        activate(0);
        tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => activate(i), opts);
          tab.addEventListener('keydown', event => {
            const keys = { ArrowRight: (i + 1) % tabs.length, ArrowDown: (i + 1) % tabs.length, ArrowLeft: (i + tabs.length - 1) % tabs.length, ArrowUp: (i + tabs.length - 1) % tabs.length, Home: 0, End: tabs.length - 1 };
            if (!(event.key in keys)) return;
            event.preventDefault();
            activate(keys[event.key], true);
          }, opts);
        });
        root.querySelectorAll('[data-story-next]').forEach(button => button.addEventListener('click', () => {
          const index = panels.indexOf(button.closest('[data-story-panel]'));
          activate((index + 1) % panels.length, true);
        }, opts));
        const mq = matchMedia('(max-width:749px)');
        const orient = () => root.querySelector('[role="tablist"]').setAttribute('aria-orientation', mq.matches ? 'horizontal' : 'vertical');
        orient();
        mq.addEventListener('change', orient, opts);
      }
      const dialog = root.querySelector('dialog');
      const opener = root.querySelector('[data-story-archive-open]');
      if (dialog && opener) {
        opener.addEventListener('click', () => {
          if (!dialog.open) dialog.showModal();
        }, opts);
        root.querySelector('[data-story-archive-close]')?.addEventListener('click', () => dialog.close(), opts);
        dialog.addEventListener('close', () => opener.focus({ preventScroll: true }), opts);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
        }, opts);
      }
      if (window.Shopify?.designMode) {
        root.addEventListener('shopify:block:select', event => {
          const panel = event.target.closest('[data-story-panel]');
          const index = panels.indexOf(panel);
          if (index >= 0) activate(index);
        }, opts);
      }
      if ('IntersectionObserver' in window && !reduced.matches && !window.Shopify?.designMode) {
        const observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.remove('ib-story-waiting'); observer.unobserve(entry.target); }
        }), { threshold: 0.05 });
        root.querySelectorAll('[data-story-reveal]').forEach(el => { el.classList.add('ib-story-waiting'); observer.observe(el); });
        controller.signal.addEventListener('abort', () => observer.disconnect(), { once: true });
        reduced.addEventListener('change', event => {
          if (event.matches) { root.querySelectorAll('.ib-story-waiting').forEach(el => el.classList.remove('ib-story-waiting')); observer.disconnect(); }
        }, opts);
      }
      instances.set(root, controller);
    });
    updateNavigation();
  }
  function offsetHeader() {
    const header = document.querySelector('.shopify-section-header-sticky, .shopify-section-header, sticky-header');
    const position = header ? getComputedStyle(header).position : '';
    const height = position === 'fixed' || position === 'sticky' ? Math.max(0, Math.min(header.getBoundingClientRect().height, header.getBoundingClientRect().bottom)) : 0;
    document.documentElement.style.setProperty('--ib-story-header-offset', `${Math.round(height)}px`);
  }
  function updateNavigation() {
    offsetHeader();
    const links = [...document.querySelectorAll('.ib-story-chapters a[href^="#"]')];
    const sections = [...document.querySelectorAll('[data-story-chapter]')];
    const nav = document.querySelector('.ib-story-chapters');
    if (!nav) return;
    links.forEach(link => { link.hidden = !document.querySelector(link.hash); });
    const top = (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ib-story-header-offset')) || 0) + 110;
    let current = sections[0];
    sections.forEach(section => { if (section.getBoundingClientRect().top <= top) current = section; });
    links.forEach(link => {
      const on = current && link.hash === `#${current.id}`;
      link.classList.toggle('ib-story-active', on);
      if (on) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
    const progress = nav.querySelector('.ib-story-reading-progress');
    if (progress) {
      const max = document.documentElement.scrollHeight - innerHeight;
      progress.style.width = `${max > 0 ? Math.min(100, scrollY / max * 100) : 0}%`;
    }
  }
  let pending = false;
  addEventListener('scroll', () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { updateNavigation(); pending = false; });
  }, { passive: true });
  addEventListener('resize', () => { offsetHeader(); updateNavigation(); });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.ib-story').forEach(root => { instances.get(root)?.abort(); instances.delete(root); });
  });
  document.documentElement.classList.add('ib-story-ready');
  offsetHeader();
  init();
})();
